import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { createPortal } from "react-dom";
const EditorPortalContext = createContext(null);
function EditorPortalProvider({
  host,
  children
}) {
  return /* @__PURE__ */ jsx(EditorPortalContext.Provider, { value: host, children });
}
function useEditorPortalHost() {
  return useContext(EditorPortalContext);
}
function EditorPortal({ children }) {
  const host = useEditorPortalHost();
  if (!host) return null;
  return createPortal(children, host);
}
export {
  EditorPortal,
  EditorPortalProvider,
  useEditorPortalHost
};
//# sourceMappingURL=EditorPortal.mjs.map
